import React,{useContext} from 'react';
import { GlobalContext } from '../context/GlobalState';

export const IncomeExpenses = () => {
  const { transaction } = useContext(GlobalContext);

  const amount = transaction.map( (transaction) => transaction.amount )

  const income = amount
  .filter(item => item > 0)
  .reduce((acc,item) => acc += item,0)
  .toFixed(2)
  
  const expense = amount
  .filter(item => item < 0)
  .reduce((acc,item) => acc += item,0)
  .toFixed(2)

    return (
        <div className="inc-exp-container">
        <div>
          <h4>Income</h4>
          <p className="money plus">{income}{` `}Rs</p>
        </div>
        <div>
          <h4>Expense</h4>
          <p className="money minus">{expense}{` `}Rs</p>
        </div>
      </div>
    )
}

export default IncomeExpenses;
